import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  source: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  dimensions: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

// This component can be used anywhere an image/icon element(s) is needed.
// We explicitly pass in a `className` prop so that in the event that
// this component is styled via Styled Components, it will have this
// attribute available (SC relies on `className` to inject the styles).
export const Image = ({ source, altText, dimensions, className, onClick }) => {
  const noFn = () => 'A valid onClick function was not provided.';

  return (
    <img
      onClick={onClick && typeof onClick !== 'function' ? noFn : onClick}
      className={className ? className : ''}
      style={dimensions ? { ...dimensions } : null}
      src={source ? source : ''}
      alt={altText ? altText : ''}
    />
  );
};

Image.propTypes = propTypes;
